import { render, staticRenderFns } from "./ManageCourse.vue?vue&type=template&id=be4583e2"
import script from "./ManageCourse.vue?vue&type=script&lang=ts"
export * from "./ManageCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports